import React from 'react';
import { Button, ButtonGroup, DropdownButton, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';

import { Table, Driver } from 'services/action';
import { FormInput, FormUser } from './create';

const initialState = {
  privilege: null,
  isShow: false,
  isUpdate: false,
  createUser: false,
  updateUser: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector((state) => state?.Table?.data['driver']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Driver.Delete']
  );

  const [{ privilege, isShow, isUpdate, createUser, updateUser }, setState] =
    React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.driver',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isShow: false,
      isUpdate: false,
      isDefault: false,
      createUser: false,
      updateUser: false,
    }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Driver.$delete(data?.id));
    if (del?.message === 'success') {
      onRefresh();
    }
  };

  const $handleUseUser = async () => {
    const del = await Dispatch(Driver.$useUser(data?.id));
    if (del?.message === 'success') {
      onRefresh();
    }
  };

  const onRefresh  = async () => {
    $handleClose();
    Dispatch(Table.$reload('driver', StateTable));
  }

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  if (privilege?.action === 'manage' || !Session?.privileges) {
    return (
      <>
        <DropdownButton
          as={ButtonGroup}
          variant="transparent"
          size="md"
          className="no-carret tbl-action"
          title={<Fi.FiMoreVertical size={13} color="gray" />}
        >
          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isUpdate: true }))
            }
          >
            <Fi.FiEdit size={15} color="#202020" className="me-2" />
            Perbaharui
          </button>

          {data?.user_id === '' ? (
            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() =>
                setState((prevState) => ({ ...prevState, createUser: true }))
              }
            >
              <Fi.FiUser size={15} color="#202020" className="me-2" />
              Buat User
            </button>
          ) : (
            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() =>
                setState((prevState) => ({ ...prevState, updateUser: true }))
              }
            >
              <Fi.FiUser size={15} color="#202020" className="me-2" />
              Perbaharui User
            </button>
          )}

          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
          >
            <Fi.FiTrash2 size={15} className="me-2" />
            Hapus
          </button>
        </DropdownButton>

        {/* modal delete */}
        <Modal
          show={isShow}
          onHide={$handleClose}
          backdrop="static"
          centered
          className="text-center"
          size="small"
        >
          <Modal.Body>
            <div className="btn-close" onClick={$handleClose} />
            <div className="modal-status bg-danger" />
            <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-danger fw-semibold">
              Data yang sudah dihapus tidak bisa dipulihkan
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="row w-100">
              <div className="col">
                <Button
                  variant="white"
                  className="w-100"
                  onClick={$handleClose}
                >
                  Batal
                </Button>
              </div>
              <div className="col">
                <Button
                  variant="danger"
                  className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                  onClick={$handleDelete}
                  disabled={StateLoading}
                >
                  Hapus
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        {/* modal create user */}
        <Modal
          show={createUser}
          onHide={$handleClose}
          backdrop="static"
          centered
          className="text-center"
          size="small"
        >
          <Modal.Body>
            <div className="btn-close" onClick={$handleClose} />
            <div className="modal-status bg-primary" />
            <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-primary fw-semibold">
              Driver ini akan dibuatkan user, username dan password adalah nama driver dengan huruf kecil
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="row w-100">
              <div className="col">
                <Button
                  variant="white"
                  className="w-100"
                  onClick={$handleClose}
                >
                  Batal
                </Button>
              </div>
              <div className="col">
                <Button
                  variant="primary"
                  className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                  onClick={$handleUseUser}
                  disabled={StateLoading}
                >
                  Simpan
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        {/* modal perbaharui user */}
        <Modal
          show={updateUser}
          onHide={$handleClose}
          backdrop="static"
          centered
          className="text-center"
          size="small"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Perbaharui User</Modal.Title>
          </Modal.Header>
          <FormUser onClose={$handleClose} onSuccess={onRefresh} uid={data?.user_id} />
        </Modal>

        <Modal
          show={isUpdate}
          onHide={$handleClose}
          backdrop="static"
          centered
          size="xl"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Perbaharui Driver</Modal.Title>
          </Modal.Header>
          <FormInput onClose={$handleClose} data={data} />
        </Modal>
      </>
    );
  }

  return false;
};

export default Action;
